import { render, staticRenderFns } from "./buildingManageList.vue?vue&type=template&id=447a8f2c&scoped=true"
import script from "./buildingManageList.vue?vue&type=script&lang=js"
export * from "./buildingManageList.vue?vue&type=script&lang=js"
import style0 from "./buildingManageList.vue?vue&type=style&index=0&id=447a8f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a8f2c",
  null
  
)

export default component.exports